var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrisolarisplanets = function SvgTrisolarisplanets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_15919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.375 8.13916C31.1193 8.13916 31.7227 7.53579 31.7227 6.7915C31.7227 6.04721 31.1193 5.44385 30.375 5.44385C29.6307 5.44385 29.0273 6.04721 29.0273 6.7915C29.0273 7.53579 29.6307 8.13916 30.375 8.13916Z",
    fill: "#9BCADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2051 11.0264C47.9494 11.0264 48.5527 10.423 48.5527 9.67871C48.5527 8.93442 47.9494 8.33105 47.2051 8.33105C46.4608 8.33105 45.8574 8.93442 45.8574 9.67871C45.8574 10.423 46.4608 11.0264 47.2051 11.0264Z",
    fill: "#C6E0EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8765 38.4526C43.6208 38.4526 44.2241 37.8493 44.2241 37.105C44.2241 36.3607 43.6208 35.7573 42.8765 35.7573C42.1322 35.7573 41.5288 36.3607 41.5288 37.105C41.5288 37.8493 42.1322 38.4526 42.8765 38.4526Z",
    fill: "#F0F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2158 45.6699C34.9601 45.6699 35.5635 45.0666 35.5635 44.3223C35.5635 43.578 34.9601 42.9746 34.2158 42.9746C33.4715 42.9746 32.8682 43.578 32.8682 44.3223C32.8682 45.0666 33.4715 45.6699 34.2158 45.6699Z",
    fill: "#9BCADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23193 22.5737C8.97622 22.5737 9.57959 21.9704 9.57959 21.2261C9.57959 20.4818 8.97622 19.8784 8.23193 19.8784C7.48764 19.8784 6.88428 20.4818 6.88428 21.2261C6.88428 21.9704 7.48764 22.5737 8.23193 22.5737Z",
    fill: "#F0F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6493 45.1394H47.8317V44.3218C47.8317 43.5775 47.2283 42.9741 46.4841 42.9741C45.7398 42.9741 45.1364 43.5775 45.1364 44.3218V45.1394H44.3188C43.5746 45.1394 42.9712 45.7427 42.9712 46.487C42.9712 47.2313 43.5746 47.8347 44.3188 47.8347H45.1364V48.6522C45.1364 49.3965 45.7398 49.9999 46.4841 49.9999C47.2283 49.9999 47.8317 49.3965 47.8317 48.6522V47.8347H48.6493C49.3936 47.8347 49.997 47.2313 49.997 46.487C49.997 45.7427 49.3936 45.1394 48.6493 45.1394Z",
    fill: "#C6E0EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0039 46.2191C31.0391 41.1838 31.0392 33.02 26.0039 27.9848C20.9687 22.9495 12.8049 22.9495 7.76956 27.9848C2.73426 33.0201 2.73423 41.1839 7.76949 46.2192C12.8048 51.2545 20.9686 51.2544 26.0039 46.2191Z",
    fill: "#00F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9876 32.6778C45.5152 32.6778 49.9962 28.1968 49.9962 22.6692C49.9962 17.1416 45.5152 12.6606 39.9876 12.6606C34.46 12.6606 29.979 17.1416 29.979 22.6692C29.979 28.1968 34.46 32.6778 39.9876 32.6778Z",
    fill: "#FF6378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0696 16.3094C23.3355 14.9556 24.8857 11.2107 23.532 7.94477C22.1782 4.67886 18.4333 3.12873 15.1674 4.48245C11.9014 5.83618 10.3513 9.58114 11.705 12.847C13.0588 16.113 16.8037 17.6631 20.0696 16.3094Z",
    fill: "#FFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 24.2085V49.9997C24.0013 49.9997 29.7863 44.2147 29.7863 37.1041C29.7863 29.9935 24.0013 24.2085 16.8906 24.2085Z",
    fill: "#00B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7864 37.1041C29.7864 29.9934 24.0014 24.2085 16.8907 24.2085C11.3345 24.2085 6.58764 27.7408 4.77783 32.6778H18.3343C19.183 32.6778 19.8736 33.3683 19.8736 34.2171C19.8736 35.0795 19.175 35.7564 18.3343 35.7564H15.4473C13.1575 35.7564 11.2127 37.6029 11.2127 39.991C11.2127 42.3259 13.1124 44.2256 15.4473 44.2256H27.636C28.9939 42.1837 29.7864 39.7348 29.7864 37.1041Z",
    fill: "#00B4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7863 37.1041C29.7863 29.9934 24.0013 24.2085 16.8906 24.2085V32.6778H18.3341C19.1829 32.6778 19.8734 33.3683 19.8734 34.2171C19.8734 35.0795 19.1749 35.7564 18.3341 35.7564H16.8906V44.2257H27.6358C28.9937 42.1837 29.7863 39.7348 29.7863 37.1041Z",
    fill: "#0073F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9868 32.6778V12.6606C45.5056 12.6606 49.9954 17.1505 49.9954 22.6692C49.9954 28.188 45.5056 32.6778 39.9868 32.6778Z",
    fill: "#D000B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4314 24.2085H30.0977C30.2447 25.1573 30.526 26.0622 30.9206 26.9038H41.4313C42.1755 26.9038 42.7789 26.3004 42.7789 25.5562C42.7789 24.8119 42.1756 24.2085 41.4314 24.2085Z",
    fill: "#D000B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0537 18.4346H38.543C37.7987 18.4346 37.1953 19.038 37.1953 19.7822C37.1953 20.5265 37.7987 21.1299 38.543 21.1299H49.8767C49.7296 20.181 49.4483 19.2761 49.0537 18.4346Z",
    fill: "#D000B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.778 25.5562C42.778 24.8119 42.1746 24.2085 41.4303 24.2085H39.9868V26.9038H41.4302C42.1746 26.9038 42.778 26.3004 42.778 25.5562Z",
    fill: "#9330A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8209 20.8066C49.8172 20.7865 49.8133 20.7664 49.8093 20.7463C49.7666 20.5277 49.7169 20.3115 49.6601 20.0982C49.6567 20.0853 49.6531 20.0724 49.6496 20.0595C49.6209 19.9535 49.5908 19.848 49.5588 19.7434C49.5586 19.7428 49.5584 19.7422 49.5582 19.7414C49.4893 19.5168 49.4127 19.2956 49.3288 19.078C49.3286 19.0776 49.3285 19.0772 49.3283 19.0769C49.2442 18.859 49.1527 18.6448 49.0541 18.4346H39.9868V21.1299H49.877C49.8602 21.0214 49.8411 20.9138 49.8209 20.8066Z",
    fill: "#9330A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0126 10.3994C24.0126 6.87047 21.1417 3.99951 17.6128 3.99951V16.7993C21.1417 16.7993 24.0126 13.9283 24.0126 10.3994Z",
    fill: "#FF8C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_15919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

export { SvgTrisolarisplanets as ReactComponent };
export default __webpack_public_path__ + "daf57b14857b4168845c606752a415cc.svg";